import React from 'react'
import ProgressBar from "@ramonak/react-progress-bar"

export default function ProgresbarHead({HomeColor,AwayColor,Home , Away , Title}) {
    const PercentageCal=(a,b)=> {
        return (b/ (a + b))*100;
      }
  return (
    <div className='ProgressbarContainer'>
    <div className='ProgressbarContainerText'>
      <div className='ProgresbarNumberText'>{Home}</div>
      <div className='ProgresbarTitleText'><span className='ProgressbarTitle'>{Title}</span></div>
      <div className='ProgresbarNumberText'>{Away}</div>
    </div>
    <ProgressBar className='ProgressBarStyle'  completed={Away == 0 && Home == 0 ? 50 :PercentageCal(Away,Home)} animateOnRender={true} bgColor={HomeColor} height={"6px"} baseBgColor={AwayColor} labelSize="0px"  />
</div>
  )
}
